import Radium from '@flipdish/radium';
import * as Raven from 'raven-js';
import * as React from 'react';
import { Form, FormControl, FormGroup, utils } from 'react-bootstrap';
import { findDOMNode } from 'react-dom';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import * as Actions from '../../actions/Actions';
import { Track } from '../../analytics';
import * as Api from '../../Api';
import * as Data from '../../Data';
import * as DeliveryLocations from '../../DeliveryLocations';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import LoadingPanel from '../LoadingPanel';
import Toast from '../Toast';
import {
  PageTitle,
  SectionHeader,
  SectionHeaderIcon,
  Icon,
  SectionHeaderText,
  Typography
} from '../../../ui';
import FlipDishCopyRight from '../FlipDishCopyRight/index.weborder';
import { MainLayout } from '../MainLayout/MainLayout';
import { Hidden } from '@material-ui/core';
import { FixedBottomContainer } from '../FixedBottomContainer/FixedBottomContainer';
const tinycolor = require('tinycolor2');
interface Route {
  params: {
    lat: string;
    lng: string;
  };
}

interface DispatchProps {
  AddLocation: (location: Api.Geo, certainty: Store.LocationCertainty) => any;
  LoadDeliveryLocations: () => any;
  AddToast: (message: string) => any;
}

interface StateProps {
  ToastMessages: string[];
  Config: Data.Config;
  AppConfig: Data.Async<Api.AppConfig>;
  LocationGeo: Api.Geo;
  addressSuggestion: { suggestion: string; postalCode: any };
  translate: any;
  AppDesignScheme: Api.AppDesignScheme;
  isDark: boolean;
}

type Props = DispatchProps & StateProps & Route;

interface Address {
  building: string;
  street: string;
  town: string;
  postCode: string;
}

interface State extends Address {
  // Google references
  map?: google.maps.Map;
  places?: google.maps.places.PlacesService;

  // Mutable state
  center: Api.Geo;

  geocodeResults: google.maps.GeocoderResult[];

  instructions: string;
  submitting: boolean;
}

// Get the input string from a HTML input event
const targetInput = function(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): string {
  const input = (e.target as any).value;
  return input as string;
};

class NewCustomLocation extends React.Component<Props, State> {
  public validatePostCodeRef;
  public validateTownRef;
  public validateBuildingRef;
  public validateStreetRef;
  constructor(props: Props, context: any) {
    super(props, context);

    const { addressSuggestion, LocationGeo } = props;

    console.log('props.addressSuggestion ', addressSuggestion);
    this.state = {
      center: LocationGeo,
      geocodeResults: [],
      building: '',
      town: '',
      street: '',
      instructions: '',
      postCode: '',
      submitting: false
    };
    this.validatePostCodeRef = React.createRef();
    this.validateStreetRef = React.createRef();
    this.validateBuildingRef = React.createRef();
    this.validateTownRef = React.createRef();
  }

  public componentDidMount() {
    Utilities.ensureVisible(findDOMNode(this));
    this.props.Config.MapLoader.then(this.initMap);
  }

  public initMap = (tools: Data.GoogleTools) => {
    const { params, LocationGeo } = this.props;

    const query = {
      location: {
        lat: parseFloat(params.lat),
        lng: parseFloat(params.lng)
      }
    };
    tools.GeoCoder.geocode(query, this.handleGeocodeResponse);

    const options: google.maps.MapOptions = {
      center: Data.LatLng(LocationGeo),
      mapTypeControl: false, // No map type (terrain/satelite, etc)
      streetViewControl: false, // No street view ControlLabel
      zoom: 17,
      draggable: false,
      clickableIcons: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      }
    };

    const map = new google.maps.Map(document.getElementById('mapRef') as Element, options);

    this.setState({
      map,
      places: new google.maps.places.PlacesService(map)
    });
  };

  public handleGeocodeResponse = (
    results: google.maps.GeocoderResult[],
    status: google.maps.GeocoderStatus
  ) => {
    console.log('Received some geocode lookup results:', results);

    const { AppConfig, AppDesignScheme, isDark, params, addressSuggestion } = this.props;

    switch (AppConfig.status) {
      case 'pending':
      case 'none':
        return <LoadingPanel AppDesignScheme={AppDesignScheme} isDark={isDark} />;
      default:
        break;
    }

    if (addressSuggestion.suggestion && !params.lat && !params.lng) {
      // https://trello.com/c/57UyvrHD/1029-new-delivery-location-round-2
      // We don't want to trust the results of the Google Places API call.
      // Sometimes the result of the places API call is not as descriptive as the
      // input.
      // Conor's Address ("Parkfield House, Dublin, Ireland"), for example, will
      // be returned as "Mount Merrion, Ireland".
      // Instead we take the string that the user click on, and split it on comma.
      // We don't just take the first 3 elements though - we combine all address
      // fields after the third into the third.

      const suggestion = addressSuggestion.suggestion;
      const [building, street, ...rest] = suggestion.split(',').map((s) => s.trim());

      if (rest.length > 1) {
        rest.pop();
      }
      const town = rest.join(', ');
      let postCode = '';

      if (AppConfig.data.PostCodeInputLabel) {
        postCode = addressSuggestion.postalCode;
      }
      this.setState({
        geocodeResults: results,
        town,
        street,
        building,
        postCode
      });
    } else {
      if (status != google.maps.GeocoderStatus.OK) {
        Raven.captureMessage('Error loading geocode response', {
          tags: { category: 'Third party library failure' },
          extra: {
            status: status,
            results: results
          }
        });
        return;
      }

      if (results.length === 0) {
        return;
      }

      let { building, town, street, postCode } = this.state;

      try {
        const addressComponents = results[0].address_components;

        let a = '';
        let roomNumber = '';
        let streetNumber = '';

        for (const addressComponent of addressComponents) {
          if (addressComponent.types[0] === 'room') {
            roomNumber = addressComponent.long_name;
            break;
          }
        }

        for (const addressComponent of addressComponents) {
          if (addressComponent.types[0] === 'street_number') {
            streetNumber = addressComponent.long_name;
            break;
          }
        }

        a = roomNumber;

        if (streetNumber) {
          if (AppConfig.data.DeliveryAddressLayout === 2) {
            a = streetNumber;
          } else if (a != '') {
            a = `${a}, ${streetNumber}`;
          } else {
            a = streetNumber;
          }
        }

        let b = '';
        let route = '';
        let locality = '';

        for (const addressComponent of addressComponents) {
          if (addressComponent.types[0] === 'route') {
            route = addressComponent.long_name;
            break;
          }
        }

        for (const addressComponent of addressComponents) {
          if (
            addressComponent.types[0] === 'neighborhood' ||
            addressComponent.types[0] === 'sublocality'
          ) {
            locality = addressComponent.long_name;
            break;
          }
        }

        b = route;

        if (locality) {
          if (b != '') {
            b = `${b}, ${locality}`;
          } else {
            b = locality;
          }
        }

        let c = '';
        for (const addressComponent of addressComponents) {
          if (addressComponent.types[0] === 'locality') {
            c = addressComponent.long_name;
            break;
          }
        }

        let d = '';

        if (AppConfig.data.PostCodeInputLabel) {
          for (const addressComponent of addressComponents) {
            if (addressComponent.types[0] === 'postal_code') {
              d = addressComponent.long_name;
            }
          }
        }

        building = AppConfig.data.DeliveryAddressLayout === 2 ? '' : a || building;
        street = AppConfig.data.DeliveryAddressLayout === 2 && a ? a + ' ' + b : b || street;
        town = c || town;
        postCode = d || postCode;

        if (building.startsWith('Unnamed ')) {
          building = '';
        }

        if (street.startsWith('Unnamed ')) {
          street = '';
        }

        if (town.startsWith('Unnamed ')) {
          town = '';
        }
      } catch (e) {
        Raven.captureMessage('Address splitting failed', {
          tags: { category: 'Frontend error' },
          extra: {
            exception: e,
            addressComponents: results[0].address_components
          }
        });
      }
      this.setState({
        geocodeResults: results,
        town,
        street,
        building,
        postCode
      });
    }
  };

  private nonEmptyStringValidation = (field: string): 'success' | 'error' => {
    if (field) {
      return 'success';
    }
    return 'error';
  };

  public validateBuilding = () => this.nonEmptyStringValidation(this.state.building);
  public validateStreet = () => this.nonEmptyStringValidation(this.state.street);
  public validateTown = () => this.nonEmptyStringValidation(this.state.town);
  public validatePostCode = () => this.nonEmptyStringValidation(this.state.postCode);

  public handleTownChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      town: targetInput(e)
    });
  };

  public handleBuildingChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      building: targetInput(e)
    });
  };

  public handleStreetChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      street: targetInput(e)
    });
  };

  public handleDeliveryInstructionsEdit = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({
      instructions: targetInput(e)
    });
  };

  public handlePostCodeChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      postCode: targetInput(e)
    });
  };

  public handleConfirmAddress = () => {
    const {
      AppConfig,
      AppDesignScheme,
      AddToast,
      translate,
      Config,
      LoadDeliveryLocations
    } = this.props;

    const { building, center, street, town, postCode, instructions } = this.state;

    switch (AppConfig.status) {
      case 'pending':
      case 'none':
        return <LoadingPanel AppDesignScheme={AppDesignScheme} />;
      default:
        break;
    }

    if (AppConfig.data.DeliveryAddressLayout != 2 && this.validateStreet() === 'error') {
      this.validateStreetRef.current.focus();
      AddToast(translate('Please_fill_all_required_fields'));
      return;
    }
    if (AppConfig.data.DeliveryAddressLayout != 2 && this.validateBuilding() === 'error') {
      this.validateBuildingRef.current.focus();
      AddToast(translate('Please_fill_all_required_fields'));
      return;
    }
    if (AppConfig.data.DeliveryAddressLayout != 2 && this.validateTown() === 'error') {
      this.validateTownRef.current.focus();
      AddToast(translate('Please_fill_all_required_fields'));
      return;
    }

    if (AppConfig.data.PostCodeInputLabel) {
      if (this.validatePostCode() === 'error') {
        this.validatePostCodeRef.current.focus();
        AddToast(translate('Please_fill_all_required_fields'));
        return;
      }
    }
    this.setState(
      {
        submitting: true
      },
      () => {
        // Create delivery address on the server.
        DeliveryLocations.Create(Config.DeviceId, {
          AutoSelectThisLocation: false,
          DeliveryLocationId: -1,
          Coordinates: center,
          IsCustomAddress: true,
          Building: building,
          Street: street,
          Town: town,
          PostCode: postCode,
          DeliveryInstructions: instructions,
          IsDisplayed: true
        }).then((result) => {
          const id = result.data.Data;
          // TODO: Error handling
          console.log('dl create result. new ID = ' + id);
          LoadDeliveryLocations();
          this.setState({
            submitting: false
          });

          Track('Maps', 'Address Confirmed');
          Utilities.navigateTo('/delivery/' + id);
        });
      }
    );
  };

  public render(): JSX.Element {
    const { AppConfig, translate, AppDesignScheme, isDark, ToastMessages } = this.props;

    switch (AppConfig.status) {
      case 'pending':
      case 'none':
        return <LoadingPanel AppDesignScheme={AppDesignScheme} />;
      default:
        break;
    }

    const { building, street, town, instructions, submitting, postCode } = this.state;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      },
      nav: {
        ':hover': {},
        ':active': {}
      },
      secondaryActive: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      secondaryHover: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      },
      buttonSecondary: {
        backgroundColor: AppDesignScheme.Secondary,
        ':hover': {},
        ':active': {},
        ':focus': {}
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      buttonHover: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      },
      formControl: {
        color: AppDesignScheme.Tertiary,
        background: AppDesignScheme.Primary,
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .setAlpha(0.2)
          .toString(),
        ':focus': {
          borderColor: AppDesignScheme.Secondary
        }
      },
      darkFormControl: {
        color: AppDesignScheme.Primary,
        background: AppDesignScheme.Tertiary,
        borderColor: AppDesignScheme.Primary
      },
      borderSecondary: {
        borderColor: AppDesignScheme.Secondary
      }
    };

    let postCodeElement;
    if (AppConfig.data.PostCodeInputLabel) {
      postCodeElement = (
        <div>
          <label
            htmlFor="postCode"
            className="tertiary clear-margins"
            key="custom-postcode"
            style={styles.tertiary}
          >
            {AppConfig.data.DeliveryAddressLayout === 2
              ? translate('Post_code')
              : AppConfig.data.PostCodeInputLabel}
          </label>
          <FormGroup validationState={this.validatePostCode()}>
            <input
              ref={this.validatePostCodeRef}
              id="postCode"
              placeholder={
                AppConfig.data.DeliveryAddressLayout === 2
                  ? translate('Post_code')
                  : AppConfig.data.PostCodeInputLabel
              }
              value={postCode}
              onChange={this.handlePostCodeChanged}
              style={isDark ? styles.darkFormControl : styles.formControl}
              className="form-control"
              key="postcode"
              data-fd="custom-postcode"
              aria-required="true"
              aria-invalid={this.state.postCode === ''}
            />
            <FormControl.Feedback />
          </FormGroup>
        </div>
      );
    }

    let buildingTitle: JSX.Element = (
      <label
        htmlFor="BuildingOrApartment"
        className="tertiary clear-margins"
        key="custom-building"
        style={isDark ? styles.primary : styles.tertiary}
      >
        {AppConfig.data.DeliveryAddressLayout === 2
          ? translate('Building_or_apartment_number')
          : translate('Building_apartment')}
      </label>
    );

    let buildingFormGroup: JSX.Element = (
      <FormGroup
        validationState={
          AppConfig.data.DeliveryAddressLayout === 2 ? 'success' : this.validateBuilding()
        }
      >
        <input
          ref={this.validateBuildingRef}
          id="BuildingOrApartment"
          placeholder={translate('Building_or_apartment_number')}
          value={building}
          onChange={this.handleBuildingChanged}
          style={isDark ? styles.darkFormControl : styles.formControl}
          className="form-control"
          key="building"
          data-fd="custom-building"
          aria-required="true"
          aria-invalid={
            AppConfig.data.DeliveryAddressLayout === 2 ? false : this.state.building === ''
          }
        />
        {AppConfig.data.DeliveryAddressLayout === 2 && building === '' ? null : (
          <FormControl.Feedback />
        )}
      </FormGroup>
    );

    let streetTitle: JSX.Element = (
      <label
        htmlFor="streetName"
        className="tertiary clear-margins"
        style={isDark ? styles.primary : styles.tertiary}
        key="custom-street"
      >
        {AppConfig.data.DeliveryAddressLayout === 2
          ? translate('Street_name')
          : translate('Street')}
      </label>
    );
    let streetFormGroup: JSX.Element = (
      <FormGroup validationState={this.validateStreet()}>
        <input
          ref={this.validateStreetRef}
          id="streetName"
          placeholder={translate('Street_name')}
          value={street}
          onChange={this.handleStreetChanged}
          style={isDark ? styles.darkFormControl : styles.formControl}
          className="form-control"
          key="street"
          data-fd="custom-street"
          aria-required="true"
          aria-invalid={this.state.street === ''}
        />
        <FormControl.Feedback />
      </FormGroup>
    );

    let addressBuffer = [];
    if (AppConfig.data.DeliveryAddressLayout === 0) {
      addressBuffer.push(buildingTitle);
      addressBuffer.push(buildingFormGroup);
      addressBuffer.push(streetTitle);
      addressBuffer.push(streetFormGroup);
    } else {
      addressBuffer.push(streetTitle);
      addressBuffer.push(streetFormGroup);
      addressBuffer.push(buildingTitle);
      addressBuffer.push(buildingFormGroup);
    }

    return (
      <MainLayout smPaddingBottom="60px" xsPaddingBottom="60px">
        <div className="container-fluid flex flex-column">
          <div className="container flex-one xs-full-width">
            <Toast Messages={ToastMessages} AppDesignScheme={AppDesignScheme} />
            <div className="row custom-location">
              <div className="col-md-12">
                <div style={{ marginTop: '20px' }} />
                <Link to="/delivery" data-fd="custom-back">
                  <div
                    key="fd-nav"
                    className="fd-nav flex flex-align-center"
                    style={styles.nav as any}
                  >
                    <i
                      className="arrow_carrot-left tertiary"
                      aria-hidden="true"
                      style={
                        Radium.getState(this.state, 'fd-nav', ':active')
                          ? styles.secondaryActive
                          : Radium.getState(this.state, 'fd-nav', ':hover')
                          ? styles.secondaryHover
                          : isDark
                          ? styles.primary
                          : styles.tertiary
                      }
                    />
                    <p
                      className="inline-block clear-margins tertiary bold"
                      style={
                        Radium.getState(this.state, 'fd-nav', ':active')
                          ? styles.secondaryActive
                          : Radium.getState(this.state, 'fd-nav', ':hover')
                          ? styles.secondaryHover
                          : isDark
                          ? styles.primary
                          : styles.tertiary
                      }
                    >
                      <u>{translate('Back')}</u>
                    </p>
                  </div>
                </Link>
              </div>
              <div className="col-md-8 col-lg-8 col-sm-12">
                <SectionHeader>
                  <SectionHeaderIcon>
                    <Icon fontSize="large" aria-hidden color="inherit" className="ei icon_pin" />
                  </SectionHeaderIcon>

                  <SectionHeaderText
                    id="skip-to-content"
                    title={translate('Delivery')}
                    subTitle={translate('Confirm_address')}
                  />
                </SectionHeader>

                <div
                  aria-hidden="true"
                  id="mapRef"
                  className="map__location"
                  style={styles.borderSecondary}
                />

                <Typography variant="h3" color="primary">
                  {translate('Enter_following_information')}
                </Typography>

                <Form
                  onSubmit={(event) => {
                    event.preventDefault();
                  }}
                >
                  {addressBuffer}
                  <label
                    htmlFor="cityOrTown"
                    className="tertiary clear-margins"
                    style={isDark ? styles.primary : styles.tertiary}
                  >
                    {AppConfig.data.DeliveryAddressLayout === 2
                      ? translate('City')
                      : translate('Town')}
                  </label>
                  <FormGroup validationState={this.validateTown()}>
                    <input
                      ref={this.validateTownRef}
                      id="cityOrTown"
                      placeholder={
                        AppConfig.data.DeliveryAddressLayout === 2
                          ? translate('City')
                          : translate('Town')
                      }
                      value={town}
                      onChange={this.handleTownChanged}
                      style={isDark ? styles.darkFormControl : styles.formControl}
                      className="form-control"
                      key="town"
                      data-fd="custom-town"
                      aria-required="true"
                      aria-invalid={this.state.town === ''}
                    />
                    <FormControl.Feedback />
                  </FormGroup>
                  {postCodeElement}
                  <label
                    htmlFor="deliveryInstructions"
                    className="tertiary clear-margins"
                    style={isDark ? styles.primary : styles.tertiary}
                  >
                    {translate('Delivery_instructions_optional')}
                  </label>
                  <FormGroup>
                    <textarea
                      id="deliveryInstructions"
                      onChange={this.handleDeliveryInstructionsEdit}
                      value={instructions}
                      placeholder={translate('Any_special_instructions_for_our_delivery_driver')}
                      style={isDark ? styles.darkFormControl : styles.formControl}
                      className="form-control"
                      key="instructions"
                      data-fd="custom-instructions"
                    />
                  </FormGroup>
                  <FlipDishCopyRight />
                  <div className="text-center">
                    <Hidden only={['xs', 'sm']}>
                      <button
                        disabled={submitting}
                        onClick={this.handleConfirmAddress}
                        onSubmit={this.handleConfirmAddress}
                        className="fd-button fd-button--big fd-button--secondary"
                        key="confirm-button"
                        style={
                          [
                            styles.buttonSecondary,
                            Radium.getState(this.state, 'confirm-button', ':active')
                              ? styles.buttonActive
                              : Radium.getState(this.state, 'confirm-button', ':hover')
                              ? styles.buttonHover
                              : null
                          ] as any
                        }
                        data-fd="address-confirm"
                      >
                        <p className="clear-margins primary" style={styles.primary}>
                          {translate('Confirm_address')}
                        </p>
                      </button>
                    </Hidden>
                  </div>
                </Form>
              </div>
            </div>
          </div>
          <div className="row">
            <FixedBottomContainer fixedOnly={['xs', 'sm']}>
              <Hidden mdUp>
                <button
                  disabled={submitting}
                  onClick={this.handleConfirmAddress}
                  onSubmit={this.handleConfirmAddress}
                  className={`fd-button fd-button--bottom fd-button--secondary ${
                    Utilities.isIOS ||
                    Utilities.extraOption('data-full-screen-on-mobile') === 'false'
                      ? 'fd-button--bottom-ios'
                      : ''
                  }`}
                  key="confirm-button-bottom"
                  style={
                    [
                      styles.buttonSecondary,
                      Radium.getState(this.state, 'confirm-button-bottom', ':active')
                        ? styles.buttonActive
                        : Radium.getState(this.state, 'confirm-button-bottom', ':hover')
                        ? styles.buttonHover
                        : null
                    ] as any
                  }
                  data-fd="address-confirm-bottom"
                >
                  <span className="clear-margins primary" style={styles.primary}>
                    {translate('Confirm_address')}
                  </span>
                </button>
              </Hidden>
            </FixedBottomContainer>
          </div>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state: Store.State): StateProps => {
  return {
    Config: state.flipdish.Config,
    AppConfig: state.flipdish.AppConfig,
    LocationGeo: state.flipdish.Location.geo,
    ToastMessages: state.flipdish.ToastMessages,
    addressSuggestion: state.flipdish.addressSuggestion,
    translate: getTranslate(state.locale),
    AppDesignScheme: state.appDesignScheme,
    isDark: state.flipdish.isDark
  };
};

const mapDispatchToProps = (dispatch: any): DispatchProps => {
  return {
    AddLocation: (location: Api.Geo, certainty: Store.LocationCertainty) => {
      dispatch(Actions.AddLocation(location, certainty));
    },

    LoadDeliveryLocations: () => {
      dispatch(Actions.LoadDeliveryLocations());
    },
    AddToast: (message: string) => {
      dispatch(Actions.AddToast(message));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Radium(NewCustomLocation));
